module.exports = __webpack_public_path__ + "img/gallery.d8bd241d.jpeg";